import { render, staticRenderFns } from "./BulkWorkpaperUploadDrawer.vue?vue&type=template&id=4ef7bc06"
import script from "./BulkWorkpaperUploadDrawer.vue?vue&type=script&lang=js"
export * from "./BulkWorkpaperUploadDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports